import { render, staticRenderFns } from "./formate-picker.mpx?vue&type=template&id=c637b134&isComponent&outputPath=components%2Fformate-picker5b9c855c%2Findex"
import script from "./formate-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fformate-picker5b9c855c%2Findex"
export * from "./formate-picker.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fformate-picker5b9c855c%2Findex"
import style0 from "./formate-picker.mpx?vue&type=style&index=0&id=c637b134&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_5b9c855c%22%7D&isComponent&outputPath=components%2Fformate-picker5b9c855c%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports